import { makeDefaultSelectOption } from '@components/custom-react-select'
import { useAuthenticatedUser } from '@components/hooks/use-authenticated-user'
import * as R from 'ramda'
import { parseISODate } from '@helpers/date-helper'
import { useCountries } from '@components/hooks/use-countries'
import { HrWorkerCreateSteps, HrWorkersCreateFormInputs } from '@modules/hr/workers/create/modal'
import { HrWorkerDetails } from '@modules/hr/workers/models'
import { BaseHrFieldDefaults, PersonalDocumentTypeOptions } from '@modules/hr/consts'
import { useHrResortOptions } from '@modules/hr/use-hr-resort-options'

export const useHrWorkerCreateWizardDefaults = (workerDetails?: HrWorkerDetails | null) => {
  const user = useAuthenticatedUser()
  const { countriesOptions } = useCountries()

  const resortOptions = useHrResortOptions()

  const fields = HrWorkerCreateSteps.reduce((prev, curr) => [...prev, ...(curr.fields ?? [])], [])

  const defaultValues: HrWorkersCreateFormInputs = {
    ...BaseHrFieldDefaults,
    ...(workerDetails && R.pick<Partial<HrWorkersCreateFormInputs>, HrWorkerDetails>(fields, workerDetails)),
    isFormVisible: !!workerDetails,
    account_number: workerDetails?.account_number || 'PL',
    nationality: workerDetails ? makeDefaultSelectOption(countriesOptions, workerDetails.nationality) : null,
    personal_id_number_type: workerDetails
      ? makeDefaultSelectOption(PersonalDocumentTypeOptions, workerDetails.personal_id_number_type)
      : null,
    birthday: workerDetails ? parseISODate(workerDetails.birthday) : null,
    resort: workerDetails
      ? resortOptions.find(option => workerDetails.resorts?.includes(option.value))
      : user.resorts.length === 1
        ? resortOptions[0]
        : null,
  }

  return { defaultValues }
}
